export const illegalChrs   = '/?%*:|"<>\\' // must end in \\ !
const illegalChrsRx = illegalChrs+'\\'

const replaceIllegals = new RegExp('['+illegalChrsRx+']', 'g')
const matchIllegals = new RegExp('['+illegalChrsRx+']')

export function cleanFileName(input: string): string {
    return input.replace(replaceIllegals, '');
}

export function containsIllegalChrs (fname: string) {
    return matchIllegals.test(fname)
}

const endsDotGpx = /\.gpx$/i

export function appendDotGpxTo (fname: string) {
    return endsDotGpx.test(fname) ? fname : fname + ".gpx"
}

export function removeDotGpxFrom (fname: string) {
    const trimmed = fname.trim()
    return endsDotGpx.test(trimmed) ? fname.substr(0, trimmed.length - '.gpx'.length) : fname
}
